const InfoOutlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_40012944_8722)">
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="white"
          strokeOpacity="0.4"
          strokeWidth="2"
        />
        <rect
          x="11"
          y="11"
          width="2"
          height="6"
          rx="1"
          fill="white"
          fillOpacity="0.4"
        />
        <circle cx="12" cy="8" r="1" fill="white" fillOpacity="0.4" />
      </g>
      <defs>
        <clipPath id="clip0_40012944_8722">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InfoOutlineIcon
